import { useEffect, useState, useContext } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Popover } from "react-bootstrap";
import Web3 from "web3";
import * as API from "../../utils/services/api";
import axios from "axios";
import {
  fetchCondo,
  fetchEth,
  fetchAurusX,
  fetchIndexCoopDetail,
} from "../../utils/services/api";
import NathaninCarImg from "../../assets/naffan_in_car_1_cote6w.png";
import { mapleABI } from "../../utils/constant/abi";
import { brickkenABI } from "../../utils/constant/abi";
import { indexCoopABI } from "../../utils/constant/abi";
import { polytradeABI } from "../../utils/constant/abi";
import { usdcABI } from "../../utils/constant/abi";
import { devCondoABI } from "../../utils/constant/abi";
import { fetchCoinDetail } from "../../utils/services/api";
import CondoLogo from "../../assets/condobannerlogo.svg";
import { TreasuryContext } from "../../context/TreasuryContextProvider";
import "./Banner.css";
const Banner = () => {
  let { setTotalTreasury } = useContext(TreasuryContext);
  const condoABI = [
    {
      inputs: [
        { internalType: "address", name: "_uniswapV2Router", type: "address" },
        { internalType: "address", name: "_treasuryWallet", type: "address" },
        { internalType: "uint256", name: "_threshold", type: "uint256" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "allowance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        { internalType: "address", name: "sender", type: "address" },
        { internalType: "uint256", name: "balance", type: "uint256" },
        { internalType: "uint256", name: "needed", type: "uint256" },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "approver", type: "address" }],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "receiver", type: "address" }],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "sender", type: "address" }],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "spender", type: "address" }],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "owner", type: "address" }],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isExcluded",
          type: "bool",
        },
      ],
      name: "ExcludeFromFees",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "pair",
          type: "address",
        },
        { indexed: true, internalType: "bool", name: "value", type: "bool" },
      ],
      name: "SetAutomatedMarketMakerPair",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "automatedMarketMakerPairs",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "buyFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "sellFee",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "value", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "treasuryWallet",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Pair",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "uniswapV2Router",
      outputs: [
        {
          internalType: "contract IUniswapV2Router02",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];
  const isMobile = window.innerWidth < 600;
  const aurusXABI = [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "bytes32",
          name: "details",
          type: "bytes32",
        },
      ],
      name: "ForceTransfer",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint8",
          name: "version",
          type: "uint8",
        },
      ],
      name: "Initialized",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "account", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "childChainManagerProxy",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "subtractedValue", type: "uint256" },
      ],
      name: "decreaseAllowance",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "user", type: "address" },
        { internalType: "bytes", name: "depositData", type: "bytes" },
      ],
      name: "deposit",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "sender_", type: "address" },
        { internalType: "address", name: "recipient_", type: "address" },
        { internalType: "uint256", name: "amount_", type: "uint256" },
        { internalType: "bytes32", name: "details_", type: "bytes32" },
      ],
      name: "forceTransfer",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "addedValue", type: "uint256" },
      ],
      name: "increaseAllowance",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "string", name: "name_", type: "string" },
        { internalType: "string", name: "symbol_", type: "string" },
      ],
      name: "initialize",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "pauseTransfers",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "resumeTransfers",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "from", type: "address" },
        { internalType: "address", name: "to", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newChildChainManagerProxy",
          type: "address",
        },
      ],
      name: "updateChildChainManager",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "withdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ];
  const [loadingTreasury, setLoadingTreasury] = useState(true);

  const condoAirdropAddress = "0x1aaed91A496d8D875A33820d09b2a68541Fb8B3D";
  const baseWalletAddress = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const aurusXContractAddress = "0x1a763170B96F23f15576D0fa0b2619d1254c437d";
  const usdcContract = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
  const [totalBalance, setTotalBalance] = useState(null);
  const [totalCondo, setTotalCondo] = useState(null);
  const [totalCondo1, setTotatCondo1] = useState(null);
  const [totalMaple, setTotalMaple] = useState(null);
  const [condoBal, setCondoBal] = useState(null);
  const [tradeBal, setTradeBal] = useState({});
  const [totalPolyTrade, setTotalPolyTrade] = useState({});

  const [totalUSDC, setTotalUSDC] = useState(null);
  const [totalUSDCBal, setTotalUSDCBal] = useState(null);
  const [ethBal, setEthBal] = useState(null);
  const [mapleBal, setMapleBal] = useState(null);
  const [brickkenBal, setBrickkenBal] = useState(null);
  const [indexCoopBal, setIndexCoopBal] = useState(null);
  const [condoTrans, setCondoTrans] = useState(null);
  const [condoTrans2, setCondoTrans2] = useState(null);
  const [mapleTrans, setMapleTrans] = useState(null);
  const [totalBrickken, setTotalBrickken] = useState(null);
  const [totalIndexCoop, setTotalIndexCoop] = useState(null);
  const [ethTrans, setEthTrans] = useState(null);
  const [polyBal, setPolyBal] = useState(null);
  const [devWalletBal, setDevWalletBal] = useState(null);
  const [totalDevWalletCondo, setTotalDevWalletCondo] = useState(null);
  const addressToCheck = "0x6404B20B5a8493c426b6efBE52809B206b26d393";
  const polyAddressToCheck = "0xbfcb93B769B0D0f6dD50974b3879B271bf6330d0";
  const mapleContract = "0x33349B282065b0284d756F0577FB39c158F935e6";
  const syrupContract = "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66";
  const brickkenContract = "0x0e28bC9B03971E95acF9ae1326E51ecF9C55B498";
  const indexCoopContract = "0xC884646E6C88d9b172a23051b38B0732Cc3E35a6";
  const devAddress = "0xEf3E49a3197417ccDbF5F6A60D89f7Fa4823199d";
  const devCondoContract = "0x30D19Fb77C3Ee5cFa97f73D72c6A1E509fa06AEf";
  const polytradeAddress = "0x692AC1e363ae34b6B489148152b12e2785a3d8d6";
  const condoPolygonTreasury = "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
  // const Link = ({ id, children, title }) => (
  //   <OverlayTrigger
  //     placement="right"
  //     overlay={<Tooltip id={id}>{title}</Tooltip>}
  //   >
  //     <a href="#">{children}</a>
  //   </OverlayTrigger>
  // );
  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );

    //Get condo balance
    const tokenContract = new web3.eth.Contract(condoABI, baseWalletAddress);
    async function getBalance() {
      try {
        const balance = await tokenContract.methods
          .balanceOf(addressToCheck)
          .call();
        const condoBalance = web3.utils.fromWei(balance, "ether");
        setEthBal(condoBalance);
        const exchangeRateResponse = await fetchCondo();
        const condoToUsdrates = exchangeRateResponse.current_price;

        setTotatCondo1(
          Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
        );
        setCondoTrans(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }

    getBalance();

    web3.eth.getBalance(addressToCheck).then(async (balance) => {
      const condoBalance = web3.utils.fromWei(balance, "ether");
      const exchangeRateResponse = await fetchEth();

      const ethToUsdRates = exchangeRateResponse.current_price;

      setTotalBalance(
        Number(parseFloat(condoBalance * ethToUsdRates).toFixed(2))
      );
      setEthTrans(parseFloat(condoBalance * ethToUsdRates).toFixed(2));
    });
    // web3.eth.getBalance(baseWalletAddress).then(async (balance) => {
    //   const condoRealBalance = 5000000000;
    //   const exchangeRateResp = await axios.get(
    //     "https://api.coingecko.com/api/v3/simple/price?ids=condo&vs_currencies=usd"
    //   );
    //   const condoToUsdrates = exchangeRateResp.data.condo.usd;
    //   const totalCondobalance = parseFloat(
    //     condoRealBalance * condoToUsdrates
    //   ).toFixed(2);
    //   setTotalCondo(Number(totalCondobalance).toLocaleString());
    //   console.log("condoBalance", condoRealBalance);
    // });
  }, []);

  useEffect(() => {
    const web3 = new Web3(
      "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
    );
    const tokenContract = new web3.eth.Contract(condoABI, baseWalletAddress);
    async function getBalance() {
      try {
        const balance = await tokenContract.methods
          .balanceOf(condoAirdropAddress)
          .call();
        const condoBalance = web3.utils.fromWei(balance, "ether");
        setCondoBal(condoBalance);
        const exchangeRateResponse = await fetchCondo();
        const condoToUsdrates = exchangeRateResponse.current_price;
        setCondoTrans2(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
        setTotalCondo(
          Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
        );
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }

    getBalance();
  }, []);

  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://polygon-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );
  //   // const tokenContract = new web3.eth.Contract(
  //   //   aurusXABI,
  //   //   aurusXContractAddress
  //   // );
  //   async function getBalance() {
  //     try {
  //       // const balance = await tokenContract.methods
  //       //   .balanceOf(polyAddressToCheck)
  //       //   .call();
  //       // const bal = 15000000000000000000000n;
  //       // const condoBalance = web3.utils.fromWei(bal, "ether");
  //       const condoBalance = 25417;
  //       const exchangeRateResponse = await fetchAurusX();
  //       const condoToUsdrates = exchangeRateResponse.current_price;
  //       // setCondoTrans2(parseFloat(condoBalance * condoToUsdrates).toFixed(2));
  //       setPolyBal(
  //         Number(parseFloat(condoBalance * condoToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }

  //   getBalance();
  // }, []);

  // MapleABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://eth-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(mapleABI, syrupContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const mapleBalance = web3.utils.fromWei(balance, "ether");
  //       setMapleBal(mapleBalance);

  //       const exchangeRateResponse = await fetchCoinDetail("syrup"); // maple
  //       const mapleToUsdrates = exchangeRateResponse.current_price;

  //       setTotalMaple(
  //         Number(parseFloat(mapleBalance * mapleToUsdrates).toFixed(2))
  //       );
  //       // setMapleTrans(parseFloat(mapleBalance * mapleToUsdrates).toFixed(2));
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // BrickkenABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://bnb-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(brickkenABI, brickkenContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const brickkenBal = web3.utils.fromWei(balance, "ether");
  //       setBrickkenBal(brickkenBal);

  //       const exchangeRateResponse = await fetchCoinDetail("brickken");
  //       const brickkenToUsdrates = exchangeRateResponse.current_price;

  //       setTotalBrickken(
  //         Number(parseFloat(brickkenBal * brickkenToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // indexCoopABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(
  //     indexCoopABI,
  //     indexCoopContract
  //   );
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const indexCoopBal = web3.utils.fromWei(balance, "ether");
  //       setIndexCoopBal(indexCoopBal);

  //       // const exchangeRateResponse = await fetchCoinDetail("index-coop-ethereum-2x-index");
  //       // const indexCoopToUsdrates = exchangeRateResponse.current_price;

  //       const indexCoopToUsdrates = await fetchIndexCoopDetail();
  //       setTotalIndexCoop(
  //         Number(parseFloat(indexCoopBal * indexCoopToUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // devWalletCondoABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(devCondoABI, devCondoContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(devAddress)
  //         .call();

  //       const devWalletBal = web3.utils.fromWei(balance, "ether");
  //       setDevWalletBal(devWalletBal);

  //       const exchangeRateResponse = await fetchCondo();
  //       const devCondoToUsdrates = exchangeRateResponse.current_price;
  //       setTotalDevWalletCondo(
  //         Number(parseFloat(devWalletBal * devCondoToUsdrates).toFixed(2))
  //       );
  //       // console.log("totaldevWalletCondo", totalDevWalletCondo);
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);

  // USDCABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://base-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(usdcABI, usdcContract);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(addressToCheck)
  //         .call();

  //       const totalUSDC = Number(balance) / 1e6;

  //       setTotalUSDCBal(totalUSDC);
  //       const exchangeRateResponse = await fetchCoinDetail("usd-coin");
  //       const usdcToUsdrates = exchangeRateResponse.current_price;
  //       setTotalUSDC(Number(parseFloat(totalUSDC * usdcToUsdrates).toFixed(2)));
  //       // console.log("totaldevWalletHomeCondo", totalDevWalletCondo);
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);
  const [allTreasuryData, setAllTreasuryData] = useState([]);
  const [allTreasuryTokenData, setAllTreasuryTokenData] = useState([]);
  const [totalTreasuryBalance, setTotalTreasuryBalance] = useState(null);

  // polytradeABI
  // useEffect(() => {
  //   const web3 = new Web3(
  //     "https://polygon-mainnet.g.alchemy.com/v2/AVp50h8nie8CF4LhvSjATb8_zEi3TLIE"
  //   );

  //   //Get balance
  //   const tokenContract = new web3.eth.Contract(polytradeABI, polytradeAddress);
  //   async function getBalance() {
  //     try {
  //       const balance = await tokenContract.methods
  //         .balanceOf(condoPolygonTreasury)
  //         .call();

  //       const totalPolyTrade = web3.utils.fromWei(balance, "ether");
  //       setPolyBal(totalPolyTrade);
  //       const polytradetoUsdrates = (await fetchCoinDetail("polytrade"))
  //         .current_price;
  //       setTotalPolyTrade(
  //         Number(parseFloat(totalPolyTrade * polytradetoUsdrates).toFixed(2))
  //       );
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //     }
  //   }
  //   getBalance();
  // }, []);
  // const popover = (
  //   <Popover id="popover-basic">
  //     <Popover.Header as="h3">
  //       How is the total treasury calculated?
  //     </Popover.Header>
  //     <Popover.Body>
  //       From{" "}
  //       {`${
  //         condoAirdropAddress.slice(0, 4) +
  //         "..." +
  //         condoAirdropAddress.slice(-4)
  //       }`}{" "}
  //       , {`${addressToCheck.slice(0, 4)}...${addressToCheck.slice(-4)}`},{" "}
  //       {`${polyAddressToCheck.slice(0, 4)}...${polyAddressToCheck.slice(-4)}`},{" "}
  //       {`${syrupContract.slice(0, 4)}...${syrupContract.slice(-4)}`}{" "}
  //       {`${brickkenContract.slice(0, 4)}...${brickkenContract.slice(-4)}`},{" "}
  //       {`${indexCoopContract.slice(0, 4)}...${indexCoopContract.slice(-4)}`}{" "}
  //       {`${polytradeAddress.slice(0, 4)}...${polytradeAddress.slice(-4)}`} and{" "}
  //       {`${usdcContract.slice(0, 4)}...${usdcContract.slice(-4)}`} we get{" "}
  //       {`${totalCondo}, ${totalCondo1}, ${totalBalance}, ${polyBal}, ${totalMaple}, ${totalBrickken}, ${totalIndexCoop},${totalPolyTrade} and ${totalUSDC}`}
  //       : Adding All
  //     </Popover.Body>
  //   </Popover>
  // );
  useEffect(() => {
    const fetchTreasuryData = async () => {
      try {
        setLoadingTreasury(true);
        const resp = await API.getAllTreasuryToken();
        setAllTreasuryData(resp.data?.totalBalance);
        setAllTreasuryTokenData(resp.data?.treasuryTokens);
      } catch (error) {
        console.error("Error fetching treasury data:", error);
      } finally {
        setLoadingTreasury(false);
      }
    };

    fetchTreasuryData();

    const intervalId = setInterval(fetchTreasuryData, 30000);

    return () => clearInterval(intervalId);
  }, []);
  const tokenAddressMap = {
    condo: condoAirdropAddress,
    eth: addressToCheck,
    trade: polyAddressToCheck,
    syrup: syrupContract,
    bkn: brickkenContract,
    eth2x: indexCoopContract,
    dev: devAddress,
  };
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">
        How is the total treasury calculated?
      </Popover.Header>
      <Popover.Body>
        {allTreasuryTokenData.map((token, index) => {
          const address = tokenAddressMap[token.symbol.toLowerCase()];
          const shortAddress = address
            ? ` from ${address.slice(0, 4)}...${address.slice(-4)}`
            : "";

          return (
            <div key={index}>
              {token.tokenName} ({token.symbol.toUpperCase()}): $
              {token.balanceUsd?.toLocaleString()}
              {shortAddress}
            </div>
          );
        })}
        <strong>Total: ${allTreasuryData?.toLocaleString()}</strong>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="container poetsen-one-regular">
      <div className="banner">
        <div
          className=""
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div className="banner-main-nathn">
            <img src={NathaninCarImg} alt="" />{" "}
          </div>{" "}
          {/* <img
            alt="title-img"
            width=""
            height=""
            className="title-logo"
            src={CondoLogo}
          /> */}
          {/* <div className="banner-cloud-img">
            <div className="banner-img">
              <h5>Total Treasury Value</h5>
              <h1>${(totalBalance + totalCondo).toLocaleString()} </h1>{" "}
            </div>
          </div> */}
          <div className="banner-cloud-img banner-banner-cloud">
            <div className="banner-img total-treasury-a">
              <h5>Total Treasury Value</h5>
              <h1 className="total-treasury-baner-change">
                {loadingTreasury ? (
                  <div className="treasury-over-loading">
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    ${allTreasuryData && allTreasuryData?.toLocaleString()}
                    {/* <Link
                      title={`from ${condoAirdropAddress.slice(
                        0,
                        4
                      )}...${condoAirdropAddress.slice(
                        -4
                      )}, ${addressToCheck.slice(
                        0,
                        4
                      )}...${addressToCheck.slice(
                        -4
                      )} and from ${polyAddressToCheck.slice(
                        0,
                        4
                      )}...${polyAddressToCheck.slice(
                        -4
                      )} we get ${condoTrans} ${ethBal} and ${ethTrans} : (Adding All three) `}
                      id="t-1"
                    >
                      <i className="fa fa-info-circle fa-xs ms-2"></i>
                    </Link> */}
                    <OverlayTrigger
                      trigger="hover"
                      placement={isMobile ? "bottom" : "right"}
                      overlay={popover}
                    >
                      <i className="fa fa-info-circle fa-xs ms-2"></i>
                    </OverlayTrigger>
                    {/* <button
                      type="button"
                      className="btn"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      data-bs-title={` from ${condoAirdropAddress} we get ${condoBal} and from ${addressToCheck} we get ${ethBal} after adding the converted values i.e. ${condoTrans} + ${ethTrans}`}
                    >
                      <i className="fa fa-info-circle"></i>
                    </button> */}
                  </>
                )}
              </h1>
            </div>
          </div>{" "}
          {/* <div className="buy-btn-address" style={{ fontWeight: "700" }}>
            <div className="contract-add aclonica-regular pt-4">
              <span>Polygon Address:</span>
              <p id="contractAddress" className="contract-address">
                0xbfcb93B769B0D0f6dD50974b3879B271bf6330d0
              </p>
            </div>
            <div
              className="copy-btn"
              style={{ cursor: "pointer" }}
              onClick={(event) => copyContractAddress(event)}
            >
              <i id="copyIcon" className="fa fa-copy"></i>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Banner;
